import { CreateOrganizationInput } from '../types/organization.type';
import { CreateOrganizationFormValues } from '../components/Forms/create-organization-form.type';

export function mapCreateOrganizationFormValuesToInput(data: CreateOrganizationFormValues): CreateOrganizationInput {
  const commonFields = {
    type: data.type,
    name: data.name.trim(),
    description: data.description.trim() || undefined,
    address: {
      street: data.address.street.trim(),
      zipCode: data.address.zipCode.trim(),
      city: data.address.city.trim(),
      informations: data.address.informations?.trim() || undefined,
    },
    offer: {
      discount: data.discount,
      reduction: data.reduction,
      isRestricted: data.isRestricted,
    },
    members: data.selectedMembers.map((member) => member.id),
    ...(data.selectedDeliveryPoints.length > 0 && {
      deliveryPointIds: data.selectedDeliveryPoints.map((deliveryPoint) => deliveryPoint.id),
    }),
  };

  if (data.contactMode === 'existing') {
    return {
      ...commonFields,
      contactId: data.selectedContact!.id,
    };
  }

  return {
    ...commonFields,
    contact: {
      firstname: data.newContact.firstname.trim(),
      lastname: data.newContact.lastname.trim(),
      email: data.newContact.email.trim(),
      phoneNumber: data.newContact.phoneNumber.trim(),
    },
  };
}
